import {exhaustive} from '@freckle/exhaustive'
import {
  toHTMLTextDangerous,
  innerHTMLText
} from '@freckle/educator-entities/ts/common/models/html-text'
import type {MathQuestionMultipleAnswersMetadataAttrs} from '@freckle/educator-entities/ts/math/common/models/questions/question-multiple-answers'
import type {MathQuestionMultipleChoiceMetadataAttrs} from '@freckle/educator-entities/ts/math/common/models/questions/question-multiple-choice'
import type {MathQuestionRegularMetadataAttrs} from '@freckle/educator-entities/ts/math/common/models/questions/question-regular'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'

export type AlternationT = 'and' | 'or'

type Props = {
  metadata:
    | MathQuestionRegularMetadataAttrs
    | MathQuestionMultipleChoiceMetadataAttrs
    | MathQuestionMultipleAnswersMetadataAttrs
  alternationToken: AlternationT
}

export const FormattedAnswer = (props: Props) => {
  const {
    metadata: {correctAnswers},
    alternationToken
  } = props

  const {t} = useSafeTranslation('common')

  const key = alternationTokenKey(alternationToken)

  const trimmed = correctAnswers.map(a => a.trim())
  const formatted = trimmed.sort().join(` ${t(key)} `)

  return <span {...innerHTMLText(toHTMLTextDangerous(formatted))} />
}

const alternationTokenKey = (alternation: AlternationT): string => {
  switch (alternation) {
    case 'and':
      return 'ALTERNATION_TOKEN_AND'
    case 'or':
      return 'ALTERNATION_TOKEN_OR'
    default:
      return exhaustive(alternation)
  }
}
